/**
 * Maps TinyAll API error bodies to user-facing admin toast text.
 * Backend InvalidOperationException often returns message "Invalid operation"
 * with the real reason in `details`.
 */
export interface ApiErrorBody {
  message?: string;
  details?: string;
  errorCode?: string;
}

const ERROR_CODE_MESSAGES: Record<string, string> = {
  DELIVERY_PARTNER_PHONE_EXISTS: 'A delivery partner with this phone number already exists.',
  DELIVERY_RATE_OUT_OF_RANGE: 'Delivery rate is outside the allowed range.',
  DELIVERY_NETWORK_ADMIN_REASON_REQUIRED: 'A reason is required when changing hub delivery network access.',
  DELIVERY_NETWORK_HUB_ENROLLMENT_NOT_FOUND: 'This hub has no delivery network enrollment record.',
  DELIVERY_NETWORK_HUB_NOT_ENROLLED: 'Network must be enabled before enabling V2 broadcast.',
  DELIVERY_NETWORK_ADMIN_ONLY: 'Only whitelisted admins can manage hub network access.',
};

export function resolveApiErrorMessage(
  error: { error?: ApiErrorBody; message?: string } | null | undefined,
  fallback: string,
): string {
  const body = error?.error;
  if (body?.errorCode && ERROR_CODE_MESSAGES[body.errorCode]) {
    return ERROR_CODE_MESSAGES[body.errorCode];
  }
  const details = body?.details?.trim();
  if (details && details !== 'Invalid operation') {
    return details;
  }
  const message = body?.message?.trim();
  if (message && message !== 'Invalid operation') {
    return message;
  }
  return fallback;
}

export function coerceOptionalNumber(value: number | string | null | undefined): number | null {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  const n = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(n) ? n : null;
}
